import React, { useState } from "react"
import { Button, Drawer } from "antd"
import { ProfileOutlined } from "@ant-design/icons"
// @ts-ignore
import JSONInput from "react-json-editor-ajrm/es"
// @ts-ignore
import locale from "react-json-editor-ajrm/locale/en"
// @ts-ignore
import { JsonEditor as Editor } from "jsoneditor-react"
import "jsoneditor-react/es/editor.min.css"

const JsonViewer = ({ data }: { data: any }) => {
  const [visible, setVisible] = useState(false)

  const onClose = () => {
    setVisible(false)
  }

  return (
    <div>
      <Drawer
        title={data?.name || "JSON Viewer"}
        placement="right"
        onClose={onClose}
        visible={visible}
        width={"600px"}
        destroyOnClose
      >
        <JSONInput
          id="json_viewer"
          placeholder={data}
          locale={locale}
          height="550px"
          width={"100%"}
        />
      </Drawer>
      <Button type={"ghost"} size={"small"} onClick={() => setVisible(true)}>
        <ProfileOutlined />
      </Button>
    </div>
  )
}

export default JsonViewer
